import Vue from 'vue'

// Advanced Search Field components
export const advancedSearchBooleanField = Vue.component(
  'advancedSearchBooleanField',
  require('_/components/AdvancedSearchFields/BooleanField/BooleanField.vue')
    .default
)
export const advancedSearchDateField = Vue.component(
  'advancedSearchDateField',
  require('_/components/AdvancedSearchFields/CalendarField/CalendarField.vue')
    .default
)
export const advancedSearchDateTimeField = Vue.component(
  'advancedSearchDateTimeField',
  require('_/components/AdvancedSearchFields/CalendarField/CalendarField.vue')
    .default
)
export const advancedSearchOneToOneExtendedField = Vue.component(
  'advancedSearchOneToOneExtendedField',
  require('_/components/FieldTypes/Blank/Blank.vue').default
)
export const advancedSearchOneToManyExtendedField = Vue.component(
  'advancedSearchOneToManyExtendedField',
  require('_/components/FieldTypes/Blank/Blank.vue').default
)
export const advancedSearchManyToOneExtendedField = Vue.component(
  'advancedSearchManyToOneExtendedField',
  require('_/components/FieldTypes/Blank/Blank.vue').default
)
export const advancedSearchRelationshipExtendedField = Vue.component(
  'advancedSearchRelationshipExtendedField',
  require('_/components/FieldTypes/Blank/Blank.vue').default
)
export const advancedSearchFileField = Vue.component(
  'advancedSearchFileField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchInputTextField = Vue.component(
  'advancedSearchInputTextField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchSimpleTextField = Vue.component(
  'advancedSearchInputTextField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchIntegerField = Vue.component(
  'advancedSearchIntegerField',
  require('_/components/AdvancedSearchFields/IntegerField/IntegerField.vue')
    .default
)
export const advancedSearchOneToOneField = Vue.component(
  'advancedSearchOneToOneField',
  require('_/components/AdvancedSearchFields/MultiSelectField/MultiSelectField.vue')
    .default
)
export const advancedSearchOneToManyField = Vue.component(
  'advancedSearchOneToManyField',
  require('_/components/AdvancedSearchFields/MultiSelectField/MultiSelectField.vue')
    .default
)
export const advancedSearchManyToOneField = Vue.component(
  'advancedSearchManyToOneField',
  require('_/components/AdvancedSearchFields/MultiSelectField/MultiSelectField.vue')
    .default
)
export const advancedSearchRelationshipField = Vue.component(
  'advancedSearchRelationshipField',
  require('_/components/AdvancedSearchFields/MultiSelectField/MultiSelectField.vue')
    .default
)
export const advancedSearchRichTextField = Vue.component(
  'advancedSearchRichTextField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchSystemDateTimeField = Vue.component(
  'advancedSearchSystemDateTimeField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchSystemStringField = Vue.component(
  'advancedSearchSystemDateTimeField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)

// New advanced search field components
export const advancedSearchFloatNumberField = Vue.component(
  'advancedSearchFloatNumberField',
  require('_/components/AdvancedSearchFields/IntegerField/IntegerField.vue')
    .default
)
export const advancedSearchUuidField = Vue.component(
  'advancedSearchUuidField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchJsonField = Vue.component(
  'advancedSearchJsonField',
  require('_/components/AdvancedSearchFields/JsonField/JsonField.vue')
    .default
)
export const advancedSearchBigIntegerField = Vue.component(
  'advancedSearchBigIntegerField',
  require('_/components/AdvancedSearchFields/IntegerField/IntegerField.vue')
    .default
)

// New advanced search field components
export const advancedSearchLocationField = Vue.component(
  'advancedSearchLocationField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchMarkdownField = Vue.component(
  'advancedSearchMarkdownField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchTextareaField = Vue.component(
  'advancedSearchTextareaField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchModulesMultiSelectField = Vue.component(
  'advancedSearchModulesMultiSelectField',
  require('_/components/AdvancedSearchFields/MultiSelectField/MultiSelectField.vue')
    .default
)
export const advancedSearchModulesSingleSelectField = Vue.component(
  'advancedSearchModulesSingleSelectField',
  require('_/components/AdvancedSearchFields/MultiSelectField/MultiSelectField.vue')
    .default
)
export const advancedSearchPermissionsField = Vue.component(
  'advancedSearchPermissionsField',
  require('_/components/AdvancedSearchFields/MultiSelectField/MultiSelectField.vue')
    .default
)
export const advancedSearchSystemIntegerField = Vue.component(
  'advancedSearchSystemIntegerField',
  require('_/components/AdvancedSearchFields/IntegerField/IntegerField.vue')
    .default
)
export const advancedSearchAssetField = Vue.component(
  'advancedSearchAssetField',
  require('_/components/AdvancedSearchFields/MultiSelectField/MultiSelectField.vue')
    .default
)
export const advancedSearchImageField = Vue.component(
  'advancedSearchImageField',
  require('_/components/AdvancedSearchFields/MultiSelectField/MultiSelectField.vue')
    .default
)
export const advancedSearchVideoField = Vue.component(
  'advancedSearchVideoField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchColorPickerField = Vue.component(
  'advancedSearchColorPickerField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
export const advancedSearchIconField = Vue.component(
  'advancedSearchIconField',
  require('_/components/AdvancedSearchFields/InputTextField/InputTextField.vue')
    .default
)
